import React, { useState } from "react";
import Navbar from "../../../Navbar/Navbar";
import axios from "axios";
import {
    TextField,
    Button,
    Container,
    Typography,
    Grid,
    Box,
    FormGroup,
    FormControlLabel,
    Checkbox
} from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import baseURL from "../../../config";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const documentOptions = [
    { key: "crewDocument", label: "CV Document" },
    { key: "passportDocument", label: "Passport" },
    { key: "cdcDocument", label: "CDC" },
    { key: "iloDocument", label: "ILO Medical" },
    { key: "stcwDocument", label: "Basic STCW" },
    { key: "stsdsdDocument", label: "STSDSD" },
    { key: "CrewPhotoDocument", label: "Crew Photo" },
    { key: "yellowfeverDocument", label: "Yellow Fever Vaccine" },
    { key: "CovidVaccineDocument", label: "COVID 19 Vaccine" },
    { key: "watchkeepingDocument", label: "Watchkeeping (II/4)" },
    { key: "watchkeepingDocumentthree", label: "Watchkeeping (III/4)" },
    { key: "CopDocument", label: "COP (II/5)" },
    { key: "CopDocumentthree", label: "COP (III/5)" },
    { key: "medicalcare", label: "Medical Care" },
    { key: "cookcocDocument", label: "Cook COC" },
    { key: "officercocDocument", label: "Officer COC" },
    { key: "gocDocument", label: "GOC" },
    { key: "gmdssDocument", label: "GMDSS" },
    { key: "h2sDocument", label: "H2S" },
    { key: "huetDocument", label: "HUET" },
    { key: "highvoltageDocument", label: "High Voltage" },
    { key: "brmDocument", label: "BRM" },
    { key: "degreeDiplomaDocument", label: "Degree/Diploma" },
    { key: "bosietDocument", label: "BOSIET" },
    // { key: "signContratDocument", label: "Signed Contract" },
    // { key: "visaDocument", label: "Visa" },
    // { key: "ticketDocument", label: "Ticket" },
    { key: "pscrbDocument", label: "PSCRB" },
    { key: "sidDocument", label: "SID CARD" },
    { key: "AFF", label: "Advanced Fire Fighting (AFF)" },
    { key: "MFA", label: "Medical First Aid (MFA)" },
    { key: "PSSR", label: "Personal Safety and Social Responsibility (PSSR)" },
    { key: "SSO", label: "Ship Security Officer (SSO)" },
    { key: "BTM", label: "Bridge Team Management (BTM)" },
    { key: "ECDIS", label: "ECDIS" },
    // { key: "contract", label: "Contract" },
    { key: "BankDocument", label: "Bank Details" },
    { key: "Foodhandling", label: "Food Handling" },
    { key: "FastRescueBoat", label: "Fast Rescue Boat (FRB)" },
    { key: "HLA", label: "HLA" },
    { key: "ERM", label: "ERM" },
    { key: "COCVerification", label: "COC Verification" },
    { key: "GMDSSVerification", label: "GMDSS Verification" },
    { key: "MarlinTest", label: "Marlin Test" },
    { key: "PreSea", label: "Pre Sea Tranning" },
    { key: "GMDSSEndorsement", label: "GMDSS Endorsement" },
];

const AddRank = () => {
    const location = useLocation();
    const { id } = useParams();
    const [formData, setFormData] = useState({
        rankname: location.state?.rankname || "",
        post: "",
        type: "",
        subcategory: "",
        category: "",
        status: "",
        requireddocuments: ["passportDocument"]
    });
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleCheckboxChange = (e) => {
        const { value, checked } = e.target;

        // Prevent unchecking "passportDocument"
        if (value === "passportDocument" && !checked) {
            return; // Do nothing — can't uncheck
        }

        setFormData((prev) => {
            const updatedDocuments = checked
                ? [...prev.requireddocuments, value]
                : prev.requireddocuments.filter((doc) => doc !== value);
            return { ...prev, requireddocuments: updatedDocuments };
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const token = localStorage.getItem("token");

        try {
            await axios.put(`${baseURL}/api/updateRank/${id}`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            toast.success("Rank Documents updated successfully!");
            setFormData({
                post: "",
                type: "",
                subcategory: "",
                category: "",
                status: "",
                requireddocuments: []
            });
            setTimeout(() => {
                navigate("/RankTable");
            }, 2000);
        } catch (error) {
            console.error("Error adding rank:", error.response);
            toast.error(error.response.data.message || "Failed to add rank.");
        }
    };

    return (
        <>
            <Navbar />
            <Container maxWidth="md">
                <Box sx={{ mt: 5, p: 4, border: "2px solid #ddd", borderRadius: "12px", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)", backgroundColor: "#fff" }}>
                    <Typography variant="h4" sx={{ mb: 3, textAlign: "center", fontWeight: "bold" }}>
                        Assign Documents to Rank
                    </Typography>
                    <form onSubmit={handleSubmit}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <TextField label="Rank Name" name="rankname" variant="outlined" fullWidth value={formData.rankname} onChange={handleChange} required />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField label="Post" name="post" type="number" variant="outlined" fullWidth value={formData.post} onChange={handleChange} />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField label="Type" name="type" variant="outlined" fullWidth value={formData.type} onChange={handleChange} />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField label="Subcategory" name="subcategory" variant="outlined" fullWidth value={formData.subcategory} onChange={handleChange} />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField label="Category" name="category" variant="outlined" fullWidth value={formData.category} onChange={handleChange} />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField label="Status" name="status" type="number" variant="outlined" fullWidth value={formData.status} onChange={handleChange} />
                            </Grid>
                            <Grid item xs={12}>
                                <Typography variant="h6" sx={{ mb: 1 }}>
                                    Required Documents
                                </Typography>
                                <Grid container spacing={2}>
                                    {/* Left Column */}
                                    <Grid item xs={6}>
                                        <FormGroup>
                                            {documentOptions.slice(0, Math.ceil(documentOptions.length / 2)).map((doc) => (
                                                <FormControlLabel
                                                    key={doc.key} // Use backend key for uniqueness
                                                    control={
                                                        <Checkbox
                                                            checked={formData.requireddocuments.includes(doc.key)}
                                                            onChange={handleCheckboxChange}
                                                            value={doc.key} // Store backend value
                                                        />
                                                    }
                                                    label={doc.label} // Show user-friendly frontend name
                                                />
                                            ))}
                                        </FormGroup>
                                    </Grid>

                                    {/* Right Column */}
                                    <Grid item xs={6}>
                                        <FormGroup>
                                            {documentOptions.slice(Math.ceil(documentOptions.length / 2)).map((doc) => (
                                                <FormControlLabel
                                                    key={doc.key}
                                                    control={
                                                        <Checkbox
                                                            checked={formData.requireddocuments.includes(doc.key)}
                                                            onChange={handleCheckboxChange}
                                                            value={doc.key}
                                                        />
                                                    }
                                                    label={doc.label}
                                                />
                                            ))}
                                        </FormGroup>
                                    </Grid>
                                </Grid>

                            </Grid>

                            <Grid item xs={12}>
                                <Button type="submit" variant="contained"  fullWidth sx={{ borderRadius: "8px", fontWeight: "bold", backgroundColor:"#C30B12" }}>
                                    Submit
                                </Button>
                            </Grid>
                        </Grid>
                    </form>
                </Box>
            </Container>
            <ToastContainer />
        </>
    );
};

export default AddRank;